/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, ExtendContainerProps} from '@gongxigames/framework/core/fragments/BuilderY';
import {$UIText} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/UIText';

export type PanelDisplayProps = ExtendContainerProps<{
    label: string;
    value: string;
    maxWidth?: number;
    isBetHidden?: boolean;
}>;

export const $PanelDisplay: FC<PanelDisplayProps> = (props) => {
    return <$Container name='bottomPanel_display' {...props}>
        {props.children}
        <$UIText
            localeID={props.label}
            stylePreset='BET_LABEL'
            name={props.label}
            visible={!props.isBetHidden}
            responsive={{box: {y: '-25px'}}}
            maxWidth={280}
        />
        <$UIText
            text={props.value}
            maxWidth={props.maxWidth}
            stylePreset='BET_VALUE'
            name='value'
            visible={!props.isBetHidden}
            responsive={{box: {y: '13px'}}}
        />
    </$Container>;
};